$(document).on('click', '.mrk-addon-dropdown-item', function () {
    $(this)
    .closest('.mrk-frame-cart-addon-inner')
    .find('.mrk-cart-frame-add')
    .trigger('click');
});

 
(function () {
  function syncUpsellToProgressBar() {
    requestAnimationFrame(() => {
      const upsellSource = document.querySelector('.mrk-upsell-wrapper');
      const progressBarTarget = document.querySelector('.wd-collection-progress-bar');
 
      if (!upsellSource) return; // upsell block not present on this page
      if (!progressBarTarget) return; // progress bar not present
 
      // Replace the inner content of the progress bar with the upsell HTML
      progressBarTarget.innerHTML = upsellSource.innerHTML;
    });
  }
 
  // Fires in the `finally` block of updateQuantity — always runs after fetch
  document.addEventListener('cart:updated', syncUpsellToProgressBar);
 
  // Also run once on page load so the initial state is in sync
  document.addEventListener('DOMContentLoaded', syncUpsellToProgressBar);
})();
 

// document.addEventListener('DOMContentLoaded', function () {
//   const isTouchDevice = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;

//   function initPopup(wrapperSelector, iconSelector, popupSelector) {
//     document.querySelectorAll(wrapperSelector).forEach(function (wrapper) {
//       const icon = wrapper.querySelector(iconSelector);
//       const popup = wrapper.querySelector(popupSelector);

//       if (!icon || !popup) return;

//       if (!isTouchDevice()) {
//         let hideTimeout;

//         function showPopup() {
//           clearTimeout(hideTimeout);
//           popup.style.display = 'block';
//           popup.style.opacity = '1';
//           popup.style.visibility = 'visible';
//         }

//         function hidePopup() {
//           hideTimeout = setTimeout(function () {
//             popup.style.display = 'none';
//             popup.style.opacity = '0';
//             popup.style.visibility = 'hidden';
//           }, 100);
//         }

//         icon.addEventListener('mouseenter', showPopup);
//         icon.addEventListener('mouseleave', hidePopup);
//         popup.addEventListener('mouseenter', showPopup);
//         popup.addEventListener('mouseleave', hidePopup);

//       } else {
//         icon.addEventListener('click', function (e) {
//           e.stopPropagation();
//           const isVisible = popup.style.display === 'block';

//           // Close all popups first
//           document.querySelectorAll('.wd-subtotal-popup-wrapper, .wd-total-saving-popup-wrapper').forEach(function (p) {
//             p.style.display = 'none';
//             p.style.opacity = '0';
//             p.style.visibility = 'hidden';
//           });

//           if (!isVisible) {
//             popup.style.display = 'block';
//             popup.style.opacity = '1';
//             popup.style.visibility = 'visible';
//           }
//         });
//       }
//     });
//   }

//   // Init both popups
//   initPopup('.wd-cart-subtotal-wrapper', '.mrk-popup-icon', '.wd-subtotal-popup-wrapper');
//   initPopup('.mrk-saving-wrapper', '.mrk-popup-icon', '.wd-total-saving-popup-wrapper');

//   // Close on outside tap (mobile only)
//   document.addEventListener('click', function () {
//     if (!isTouchDevice()) return;
//     document.querySelectorAll('.wd-subtotal-popup-wrapper, .wd-total-saving-popup-wrapper').forEach(function (p) {
//       p.style.display = 'none';
//       p.style.opacity = '0';
//       p.style.visibility = 'hidden';
//     });
//   });
// });